import { render, staticRenderFns } from "./facet.vue?vue&type=template&id=5a99507e&"
import script from "./facet.vue?vue&type=script&lang=js&"
export * from "./facet.vue?vue&type=script&lang=js&"
import style0 from "./facet.vue?vue&type=style&index=0&id=5a99507e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports